import { JSX, SVGProps } from 'react';

export default function HeartIcon(
  props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>
) {
  return (
    <svg
      width="25"
      height="23"
      viewBox="0 0 25 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22.7208 2.34944C21.3954 1.02061 19.6385 0.209568 17.7674 0.0628181C15.8964 -0.0839319 14.0345 0.443285 12.5182 1.54923C10.9273 0.36598 8.94726 -0.170565 6.97667 0.0476484C5.00608 0.265862 3.19135 1.22262 1.89794 2.72526C0.60453 4.2279 -0.0714974 6.16481 0.00599578 8.14593C0.083489 10.127 0.908746 12.0052 2.31558 13.4022L10.0801 21.1792C10.7302 21.8191 11.6059 22.1777 12.5182 22.1777C13.4304 22.1777 14.3061 21.8191 14.9563 21.1792L22.7208 13.4022C24.1806 11.9335 25 9.94671 25 7.87584C25 5.80497 24.1806 3.81823 22.7208 2.34944ZM20.9578 11.6768L13.1933 19.4413C13.105 19.5305 12.9998 19.6013 12.8839 19.6496C12.7681 19.698 12.6437 19.7229 12.5182 19.7229C12.3926 19.7229 12.2683 19.698 12.1524 19.6496C12.0365 19.6013 11.9314 19.5305 11.843 19.4413L4.07853 11.6393C3.09798 10.637 2.5489 9.29053 2.5489 7.88835C2.5489 6.48616 3.09798 5.13971 4.07853 4.13739C5.07773 3.15088 6.42534 2.59771 7.82948 2.59771C9.23362 2.59771 10.5812 3.15088 11.5804 4.13739C11.6967 4.25458 11.835 4.3476 11.9873 4.41108C12.1397 4.47455 12.3031 4.50723 12.4682 4.50723C12.6332 4.50723 12.7966 4.47455 12.949 4.41108C13.1014 4.3476 13.2397 4.25458 13.3559 4.13739C14.3551 3.15088 15.7027 2.59771 17.1068 2.59771C18.511 2.59771 19.8586 3.15088 20.8578 4.13739C21.8518 5.12658 22.4189 6.46572 22.4376 7.86795C22.4563 9.27017 21.9251 10.624 20.9578 11.6393V11.6768Z"
        fill="#FFFF"
      />
    </svg>
  );
}
